<template>
  <div class="table-page">
    <div class="cnt-header">
      <div class="top-btn">
        <el-button-group>
          <el-button type="primary" icon="el-icon-download" @click="filesExport"
          >导出数据
          </el-button
          >
        </el-button-group>
      </div>
      <div class="search-input">
        <div class="filter-top">
          <label class="filter-label">筛选：</label>
          <el-select
              v-model="filter"
              @clear="filterClear"
              @change="filterChange"
              clearable
              placeholder="请选择负责人"
              v-show="userInfo.is_admin"
          >
            <el-option
                v-for="item in filterOpts"
                :key="item.user_id"
                :label="item.username"
                :value="item.user_id"
            >
            </el-option>
          </el-select>
          <el-date-picker
              v-model="dateValue"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="daterangeChange"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>
        <el-input
            style="width: 295px"
            :clearable="true"
            placeholder="输入(项目编号/活动名称)检索"
            class="input-with-select"
            v-model="query"
            @keyup.enter.native="startQuery"
            @clear="clearInputVal"
        >
          <el-button slot="append" icon="el-icon-search" @click="startQuery"></el-button>
        </el-input>
      </div>
    </div>

    <el-table
        :data="tableData"
        style="width: 100%"
        max-height="750"
        show-summary
        :summary-method="getSummaries"
        v-loading="loading"
        @row-dblclick="rowDbClickEdit"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
              :data="props.row.paid_details"
              style="width: 100%"
              show-summary
              :summary-method="getPaidSummaries"
          >
            <el-table-column prop="date" label="日期" class-name="success-row"></el-table-column>
            <el-table-column prop="operator" label="操作员" class-name="success-row"></el-table-column>
            <el-table-column prop="pay_type" label="付款方式" class-name="success-row"></el-table-column>
            <el-table-column prop="remark" label="备注" class-name="success-row"></el-table-column>
            <el-table-column prop="amount" label="金额" class-name="success-row"></el-table-column>
            <el-table-column label="操作" class-name="success-row">
              <template slot-scope="inner">
                <el-button
                    size="mini"
                    type="danger"
                    @click="delPaidDetail(inner.row.id)"
                >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="meet_time" label="会议时间"></el-table-column>
      <el-table-column prop="username" label="项目负责人" v-if="userInfo.is_admin">
      </el-table-column>
      <el-table-column prop="meet_num" label="项目编号"></el-table-column>
      <el-table-column prop="meet_name" label="活动名称" width="200"></el-table-column>
      <el-table-column
          prop="supplier"
          label="应付供应商"
          :filters="suppliersFilter"
          :filter-method="filterHandler"
      >
      </el-table-column>
      <el-table-column prop="pay_amount" label="应付金额" sortable></el-table-column>
      <el-table-column prop="pay_days" label="付款天数" sortable></el-table-column>
      <el-table-column label="到期日期" sortable>
        <template slot-scope="scope">
          <font v-if="currentDate < scope.row.expired">{{ scope.row.expired }}</font>
          <font v-else style="color: #F56C6C">{{ scope.row.expired }}</font>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="审核状态" ></el-table-column>
      <el-table-column fixed="right" label="操作" width="170">
        <template slot-scope="scope">
          <el-button @click="handleCashClick(scope.row.list_id)" style="color: #E6A23C" type="text" size="small">现金审批单</el-button>
          <el-button @click="handleSupplierClick(scope.row.list_id)" style="color: #E6A23C" type="text" size="small">供应商审批单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="添加付款明细" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="付款日期" :label-width="formLabelWidth" prop="date">
          <el-date-picker
              v-model="form.date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="付款金额" :label-width="formLabelWidth" prop="amount">
          <el-input-number v-model="form.amount" :min="0" :step="0.5" :precision="2"
                           autocomplete="off"></el-input-number>
        </el-form-item>
        <el-form-item label="付款方式" :label-width="formLabelWidth" prop="pay_type">
          <el-input v-model="form.pay_type" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="操作员" :label-width="formLabelWidth" prop="operator">
          <el-input v-model="form.operator" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
          <el-input v-model="form.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addPaidDetail">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getUserInfo} from "../utils/utils.js";

export default {
  data() {
    return {
      currentDate: null,
      currentListId: null,
      dialogFormVisible: false,
      form: {
        id: null,
        list_id: null,
        date: '',
        amount: 0,
        pay_type: '',
        operator: '',
        remark: ''
      },
      status: "",
      statusOpts: [
        { value: 1, label: "通过" },
        { value: -1, label: "拒绝" },
        { value: 0, label: "审核中" },
      ],
      formLabelWidth: '120px',
      loading: false,
      filterOpts: [],
      filter: null,
      tableData: [],
      userInfo: {
        is_admin: false,
        user_id: null,
        username: "",
      },
      suppliersFilter: [],
      rules: {
        date: [
          {required: true, message: "请输入收款日期", trigger: "blur"},
        ],
        amount: [
          {required: true, message: "请输入收款金额", trigger: "blur"},
        ]
      },
      query: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上一年",
            onClick(picker) {
              const now = new Date();
              const start = new Date(now.getFullYear()-1, 0, 1);
              const end = new Date(now.getFullYear()-1, 11, 31);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dateValue: [String(new Date().getFullYear())+"-01-01", String(new Date().getFullYear())+"-12-31"],
    };
  },
  methods: {
    handleCashClick(list_id){
      let that = this;
      that.fullscreenLoading = true;
      let reqUrl = that.host + "/api/cash/approve/exporter?list_id=" + list_id;
      that.$axios
          .get(reqUrl, {
            responseType: "blob",
            headers: {"Cache-Control": "no-cache"},
          })
          .then((res) => {
            let blob = new Blob([res.data]);
            let link = document.createElement("a");
            link.download = "现金审批单.pdf";
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            that.fullscreenLoading = false;
          })
          .catch((err) => {
            let resData = err.data;
            if(err.data.type == "application/json"){
              const fileReader = new FileReader();
              fileReader.onloadend = () => {
                let jsonData = JSON.parse(fileReader.result)
                // 后台信息
                that.$message.error(jsonData.errmsg);
                that.fullscreenLoading = false;
              }
              fileReader.readAsText(resData);
            }
          });
    },
    handleSupplierClick(list_id){
      let that = this;
      that.fullscreenLoading = true;
      let reqUrl = that.host + "/api/supplier/approve/exporter?list_id=" + list_id;
      that.$axios
          .get(reqUrl, {
            responseType: "blob",
            headers: {"Cache-Control": "no-cache"},
          })
          .then((res) => {
            let blob = new Blob([res.data]);
            let link = document.createElement("a");
            link.download = "供应商审批单.pdf";
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            that.fullscreenLoading = false;
          })
          .catch((err) => {
            let resData = err.data;
            if(err.data.type == "application/json"){
              const fileReader = new FileReader();
              fileReader.onloadend = () => {
                let jsonData = JSON.parse(fileReader.result)
                // 后台信息
                that.$message.error(jsonData.errmsg);
                that.fullscreenLoading = false;
              }
              fileReader.readAsText(resData);
            }
          });
    },
    delPaidDetail(id) {
      let that = this;
      that.form.id = id;
      that.$confirm('此操作将永久删除该条付款明细信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        // 执行删除操作
        that.$axios.delete(that.host + "/api/paid/details", {data: {id: id}}).then((res) => {
          that.loadDatas();
          that.$message.success("删除成功");
        }).catch((err) => {
          that.$message.error(err.data.errmsg);
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addPaidDetail() {
      let that = this;
      that.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          that.form.list_id = that.currentListId;
          that.$axios.post(that.host + "/api/paid/details", that.form)
              .then((res) => {
                that.$message.success("添加成功");
                that.dialogFormVisible = false;
                that.loadDatas();
              })
              .catch((err) => {
                that.$message.error(err.data.errmsg);
              })
        } else {
          that.$message.error("参数验证不通过")
        }
      })
    },
    rowDbClickEdit(row, column, event) {
      let that = this;
      if (row.unpaid_amount > 0) {
        that.form = {
          id: null,
          list_id: null,
          date: '',
          amount: 0,
          pay_type: '',
          operator: '',
          remark: ''
        };
        that.currentListId = row.list_id;
        that.dialogFormVisible = true;
      }
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    filesExport() {
      let that = this;
      that.fullscreenLoading = true;
      let reqUrl = that.host + "/api/payment/accounts/exporter";
      if (that.dateValue) {
        reqUrl += "?start_date=" + that.dateValue[0] + "&end_date=" + that.dateValue[1];
      }
      that.$axios
          .get(reqUrl, {
            responseType: "blob",
            headers: {"Cache-Control": "no-cache"},
          })
          .then((res) => {
            let blob = new Blob([res.data]);
            let link = document.createElement("a");
            link.download = "应付款明细.xlsx";
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            that.fullscreenLoading = false;
          })
          .catch((err) => {
            let resData = err.data;
            if(err.data.type == "application/json"){
              const fileReader = new FileReader();
              fileReader.onloadend = () => {
                let jsonData = JSON.parse(fileReader.result)
                // 后台信息
                that.$message.error(jsonData.errmsg);
                that.fullscreenLoading = false;
              }
              fileReader.readAsText(resData);
            }
          });
    },
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 3) {
          sums[index] = "合计";
          return;
        }
        if (column.label === "应付金额") {
          const values = data.map((item) => Number(item[column.property]));
          let total = 0;
          values.forEach((val, idx) => {
            total += val;
          });
          sums[index] = total.toFixed(2) + " 元";
          return;
        }
      });
      return sums;
    },
    getPaidSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      let detail;
      if (data.length > 0) {
        detail = data[0];
      } else {
        return sums;
      }
      columns.forEach((column, index) => {

        if (index === 2) {
          sums[index] = "待付金额";
          return;
        }
        if (column.label === "金额") {
          const values = data.map((item) => Number(item[column.property]));
          let total = 0;
          values.forEach((val, idx) => {
            total += val;
          });
          sums[index] = (detail.pay_amount - total).toFixed(2) + " 元";
          return;
        }
      });
      return sums;
    },
    daterangeChange() {
      let that = this;
      that.loadDatas();
    },
    filterChange() {
      let that = this;
      that.loadDatas();
    },
    filterClear() {
      let that = this;
      that.loadDatas();
    },
    startQuery() {
      let that = this;
      that.currentPage = 1;
      if (that.query) {
        if (!that.query.trim()) {
          that.query = null;
        }
      }
      that.loadDatas();
    },
    clearInputVal() {
      let that = this;
      that.loadDatas();
    },
    loadDatas() {
      let that = this;
      let reqUrl = that.host + "/api/payment/accounts?";
      if (that.query) {
        reqUrl += "&query=" + that.query;
      }
      if (that.filter) {
        reqUrl += "&user_id=" + that.filter;
      }
      if (that.dateValue) {
        reqUrl += "&start_date=" + that.dateValue[0] + "&end_date=" + that.dateValue[1];
      }
      that.loading = true;
      that.$axios
          .get(reqUrl)
          .then((res) => {
            let results = res.data.results;
            for (let i = 0; i < results.length; i++) {
              let paidDeatils = results[i].paid_details;
              let unpaidAmount = results[i].pay_amount;
              for (let j = 0; j < paidDeatils.length; j++) {
                unpaidAmount = unpaidAmount - paidDeatils[j].amount;
              }
              results[i]["unpaid_amount"] = unpaidAmount;
            }

            let supplierArr = [];
            for (let i = 0; i < results.length; i++) {
              let item = results[i]
              if ((item.supplier.trim() === "") || (supplierArr.includes(item.supplier))) {
                continue
              }
              supplierArr.push(item.supplier);
              that.suppliersFilter.push({
                text: item.supplier,
                value: item.supplier,
              })
            }
            that.tableData = results;
            that.loading = false;
          })
          .catch((err) => {
            that.loading = false;
            that.$message.error(err.data.errmsg);
          });
    },
    loadFilterOpts() {
      // 加载筛选选项
      let that = this;
      that.$axios
          .get(that.host + "/api/users/opts")
          .then((res) => {
            that.filterOpts = res.data.results;
          })
          .catch((err) => {
            that.$message.error(err.data.errmsg);
          });
    },
  },
  mounted() {
    let that = this;
    let now = new Date();
    that.currentDate = now.Format("yyyy-MM-dd");
    that.loadDatas();
    getUserInfo().then((res) => {
      that.userInfo = res;
      if (that.userInfo.is_admin) {
        that.loadFilterOpts();
      }
    });
  },
};
</script>

<style>
.filter-label {
  font-size: 14px;
  color: #e6a23c;
}

.cnt-header {
  position: relative;
  margin-bottom: 25px;
  line-height: 34px;
}

.filter-top {
  margin-right: 25px;
  display: inline-block;
}

.cnt-header .top-btn {
  display: inline-block;
}

.cnt-header .search-input {
  float: right;
}

.form-item-line {
  display: inline-block;
}

.form-item-line .left {
  float: left;
}

.table-page {
  padding: 0 30px 0 30px;
}
</style>
